export default "__VITE_ASSET__tjma6ODh__"